import { useQuery } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'

export function useWorkspaceCreditsAvailable (
  workspace: string
) {
  const cogfy = useCogfy()

  const getWorkspaceCreditsUsage = useQuery({
    queryKey: ['getWorkspaceCreditsAvailable', workspace],
    queryFn: ({ signal }) => cogfy.getWorkspaceCreditsAvailable({ signal })
  })

  return getWorkspaceCreditsUsage
}
